// import React from 'react';
// import { Icon } from 'antd';

export const confirmArchive = {
  title: 'Внимание',
  content:
    'Вы уверены, что хотите архивировать ТС? ТС будет недоступно для назначения на заказы.',
  okText: 'Архивировать',
  cancelText: 'Отмена',
  className: 'confirm-red',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
    type: 'primary',
  },
  okButtonProps: {
    style: { width: 176 },
    type: 'danger',
    ghost: true,
  },
};

export const confirmRestoreArchive = {
  title: 'Внимание',
  content:
    'Вы действительно хотите восстановить ТС? Назначение на заказы для этого ТС станет доступно.',
  okText: 'Восстановить',
  cancelText: 'Отмена',
  className: 'confirm-gray',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
  },
  okButtonProps: {
    style: { width: 176 },
  },
};

/*
export const confirmCloseEditing = {
  title: 'Внимание',
  content:
    'Вы действительно хотите отменить редактирование заказа? Несохраненные данные будут удалены!',
  okText: 'Отменить изменения',
  cancelText: 'Отмена',
  className: 'modal-save-changes',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
  okButtonProps: {
    ghost: true,
    type: 'danger',
  },
  maskClosable: true,
  icon: <Icon style={{ color: '#f5222d' }} type="question-circle" />,
  closable: true,
  mask: true,
};

export const confirmUpdate = {
  title: 'Внимание!',
  content: 'Вы действительно хотите сохранить изменения?',
  okText: 'Сохранить',
  className: 'modal-save-changes',
  cancelText: 'Отмена',
  maskClosable: true,
  icon: <Icon style={{ color: '#9b9b9b' }} type="question-circle" />,
  closable: true,
  mask: true,
};

export const confirmMailSendWithoutTheme = {
  title: 'Внимание!',
  content: 'Вы действительно хотите отправить письмо без темы?',
  okText: 'Отправить',
  className: 'modal-save-changes',
  cancelText: 'Отмена',
  maskClosable: true,
  icon: <Icon style={{ color: '#9b9b9b' }} type="question-circle" />,
  closable: true,
  mask: true,
};
*/
